import { ArrowRight } from 'lucide-react'
import { STORE_NAME } from '../config'

const lines = [
  {
    name: 'Metals, Ores & Minerals',
    text: 'Aluminium, copper and industrial ores at contract volumes — graded, assayed and shipped with full mill certificates.',
    image: 'https://images.unsplash.com/photo-1523848309072-c199db53f137?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: 'Chemicals & Industrial Ingredients',
    text: 'Food-grade and industrial chemicals, additives and processing inputs — batch-tested with certificates of analysis on every lot.',
    image: 'https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: 'Frozen Food & Meat',
    text: 'Frozen meat, poultry and prepared lines from certified processors — cold-chain integrity guaranteed port to door.',
    image: 'https://images.unsplash.com/photo-1607623814075-e51df1bdc82f?auto=format&fit=crop&w=800&q=80'
  },
  {
    name: 'Alcoholic & Non-Alcoholic Beverages',
    text: 'Branded drinks, juices, coffees and teas for distributors and hospitality groups — including private-label options.',
    image: 'https://images.unsplash.com/photo-1701769106294-b439b6b070a2?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=NHwxMjA3fDA%3D'
  },
  {
    name: 'Agricultural Products & Produce',
    text: 'Grains, cereals, seeds and fresh produce from grade-1 origins — with moisture, purity and phytosanitary certificates on every lot.',
    image: 'https://images.unsplash.com/photo-1658400669634-118509e573fb?q=80&w=774&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=NHwxMjA3fDA%3D'
  },
  {
    name: 'FMCG & Household',
    text: 'Branded and private-label consumer goods, snacks, detergents and shelf-ready products for distributors and retail chains.',
    image: 'https://images.unsplash.com/photo-1662106143538-a4da17ba7d5b?q=80&w=871&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=NHwxMjA3fDA%3D'
  }
]

export function CommodityGrid({ onNavigate }) {
  return (
    <section className="px-4 py-16 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-10 flex items-end justify-between gap-4">
          <div>
            <span className="mb-3 inline-block rounded-full border border-brand-gold/40 bg-brand-gold/10 px-3 py-1 text-xs font-semibold uppercase tracking-widest text-brand-navy">
              Our trade lines
            </span>
            <h2 className="heading-accent font-display text-2xl font-bold text-brand-ink sm:text-3xl">
              What we trade
            </h2>
            <p className="mt-4 max-w-2xl text-brand-slate">
              At {STORE_NAME}, we trade across six core lines — metals and ores, chemicals, frozen
              food and meat, beverages, agricultural produce and FMCG — in retail-ready and bulk formats.
            </p>
          </div>
          <button
            onClick={() => onNavigate('categories')}
            className="hidden shrink-0 items-center gap-2 text-sm font-semibold text-brand-navy hover:text-brand-gold sm:inline-flex"
          >
            All categories <ArrowRight className="h-4 w-4" />
          </button>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {lines.map((line) => (
            <button
              key={line.name}
              onClick={() => onNavigate('categories')}
              className="card-lift group relative h-64 overflow-hidden rounded-2xl text-left shadow-card"
            >
              <img
                src={line.image}
                alt={line.name}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white/95 via-white/60 to-transparent" />
              <div className="relative flex h-full flex-col justify-end p-6">
                <h3 className="font-display text-xl font-bold text-brand-ink">{line.name}</h3>
                <p className="mt-1 line-clamp-2 text-sm text-brand-slate">{line.text}</p>
                <span className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-brand-navy">
                  Explore <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  )
}
